import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-landing-promo',
  templateUrl: './landing-promo.component.html',
  styleUrls: ['./landing-promo.component.css']
})
export class LandingPromoComponent implements OnInit {
  activePromoCode: string = '';
  blocks: any[] = [];
  termsExpanded: boolean = true;
  isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const codeParam = params['code'];
      if (codeParam) {
        this.activePromoCode = codeParam.toUpperCase();
        this.loadLandingData(this.activePromoCode);
      } else {
        this.isLoading = false;
      }
    });
  }

  loadLandingData(code: string): void {
    this.isLoading = true;
    const formData = new FormData();
    formData.append('opr', 'Landing_Cargar');
    formData.append('code', code);

    // Sintaxis de subscribe adaptada para RxJS en Angular 10
    this.http.post<any>('https://ventas.tufesa.com.mx/wsrestwebjsonbeta/gestionarLangingPage', formData)
      .subscribe(
        (response) => {
          if (response && response.blocks) {
            this.blocks = response.blocks;
          }
          this.isLoading = false;
        },
        (err) => {
          console.error('Error loading landing page:', err);
          this.isLoading = false;
        }
      );
  }

  toggleTerms(): void {
    this.termsExpanded = !this.termsExpanded;
  }

  scrollToSteps(): void {
    const stepsElement = document.querySelector('.steps-section');
    if (stepsElement) {
      stepsElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  getHeroBullets(ofertaBeneficios: string): string[] {
    if (!ofertaBeneficios) return [];
    return ofertaBeneficios.split('\n').filter(b => b.trim() !== '');
  }

  getMaterialIcon(iconName: string): string {
    const iconMap: { [key: string]: string } = {
      'shirt': 'checkroom',
      'check': 'check',
      'bag': 'shopping_bag',
      'seat': 'airline_seat_recline_extra',
      'seat-plus': 'airline_seat_recline_normal',
      'bed': 'airline_seat_flat'
    };
    return iconMap[iconName] || iconName;
  }
}
